import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InputFieldWrapper from '../../form/InputFieldWrapper';
import Alert from '../../Alert';
import Loader from '../../Loader';
import {
  editPhoneNumber,
  editPhoneNumberConfirmation,
} from '../../../data/service/noona/actions';

import Logger from '../../../utils/Logger';

let { id: module_id } = module;
const logger = new Logger(module_id);

class CheckPhoneNumberForm extends React.Component {
  static propTypes = {
    /** Determines whether activation is currently processing. */
    activationIsFetching: PropTypes.bool,

    /** This gets populated with error if activation goes wrong. */
    activationError: PropTypes.object,

    /** Current value of phone number field. */
    phoneValue: PropTypes.string,

    /** Current value of phone confirm field. */
    phoneConfirmValue: PropTypes.string,

    /** Array of errors considering the phone field. */
    phoneErrors: PropTypes.array,

    /** Array of errors considering the phone confirm field. */
    phoneConfirmErrors: PropTypes.array,

    /** Determines whether phone number has been changed from the original */
    phoneChanged: PropTypes.bool,

    /** Action for handling changes in phone number field. */
    editPhoneNumber: PropTypes.func,

    /** Action for handling changes in phone number confirmation field. */
    editPhoneNumberConfirmation: PropTypes.func,
  };

  render() {
    let {
      activationIsFetching,
      activationError,
      phoneValue,
      phoneConfirmValue,
      phoneErrors,
      phoneConfirmErrors,
      phoneChanged,
      editPhoneNumber,
      editPhoneNumberConfirmation,
    } = this.props;

    if (activationIsFetching) {
      return <Loader />;
    }

    if (activationError) {
      return (
        <Alert
          type="error"
          className="text-center larger-text"
          isHtml
          message="noona.activation.error"
          linkText={'omatays@istekki.fi'}
          linkHref={'mailto:omatays@istekki.fi'}
        />
      );
    }

    return (
      <div>
        <Alert
          type="info"
          className="text-center larger-text"
          key="alert.check.phone.number"
        >
          <FormattedMessage id={`${module_id}.check.phone.number`} />
        </Alert>
        <InputFieldWrapper
          errors={phoneErrors}
          placeholderMessage={{
            message: { id: `${module_id}.enter.phone.number` },
          }}
          value={phoneValue}
          onChange={editPhoneNumber}
        />
        {phoneChanged && (
          <InputFieldWrapper
            errors={phoneConfirmErrors}
            placeholderMessage={{
              message: { id: `${module_id}.confirm.phone.number` },
            }}
            value={phoneConfirmValue}
            onChange={editPhoneNumberConfirmation}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { isFetching, error: activationError } = state.services.noona.activation;
  let { currentValue, confirmValue, errors, changed } =
    state.services.noona.phoneNumber;
  let { phone: phoneErrors, phoneConfirm: phoneConfirmErrors } = errors;
  return {
    activationIsFetching: isFetching,
    activationError,
    phoneValue: currentValue,
    phoneConfirmValue: confirmValue,
    phoneChanged: changed,
    phoneErrors,
    phoneConfirmErrors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editPhoneNumberConfirmation: (event) =>
      dispatch(editPhoneNumberConfirmation(event.target.value)),
    editPhoneNumber: (event) => dispatch(editPhoneNumber(event.target.value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckPhoneNumberForm);
